import React from "react";
import "video-react/dist/video-react.css";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
export default function GettingStarted() {

  return (
    <>
      <section className="font-soehne">
        <Header />
        <div className="w-full mx-auto pt-10">
          <h1 className="text-center text-3xl font-normal text-themeBlue">
            How Pacificria works?
          </h1>

          <div className="pt-10 pb-10 lg:pb-20">
            <video
              controls
              width="70%"
              style={{ margin: "auto" }}
              height="300px"
              autoPlay
            >
              <source src="/video/video.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="space-y-10">
            <h1 className="text-center text-3xl font-normal text-themeBlue">
              Process We Follow To Deliver Packages
            </h1>
            <img src="images/Steps.webp" alt="home" className="w-full h-full" />
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}
